const removeKeys = (obj, func = (k) => k) =>
  Object.keys(obj)
    .filter((k) => !func(k))
    .reduce(
      (newObj, key) => ({
        ...newObj,
        [key]: obj[key],
      }),
      {}
    );

export default removeKeys;
